/**
 * Tenant-specific auth guard. Wraps the shared ProtectedRoute with tenant
 * context: bearer-token getter, tenant-status check, and the blocked-screen UI.
 *
 * Use <RequireAuth> instead of <ProtectedRoute> inside the tenant SPA so
 * all routes share the same auth/status configuration without repetition.
 */
import { ProtectedRoute } from '@ensafely/checker-ui'
import TenantBlockedScreen from './TenantBlockedScreen'
import { checkTenantStatus } from '../lib/tenantStatusCheck'
import { getToken } from '../lib/authToken'

interface Props {
  children: React.ReactNode
}

export default function RequireAuth({ children }: Props) {
  return (
    <ProtectedRoute
      getToken={getToken}
      statusCheck={checkTenantStatus}
      BlockedFallback={TenantBlockedScreen}
    >
      {children}
    </ProtectedRoute>
  )
}
